// Import the EventBus.
export const fileHandling = {
  methods: {
    downloadPdfFromEndpoint(endpoint = false) {
      if (!endpoint) {
        return
      }

      axios.get(endpoint).then((response) => {
        if (response.data.success && response.data.fileurl) {
          // let filename = 'download'
          // if (response.data.filename) filename = response.data.filename

          FileSaver.saveAs(response.data.fileurl, { type: 'application/pdf' })

          /** IF we want to stream the file : */
          // FileSaver.saveAs(
          //     new Blob([atob(response.data.fileblob)],
          //     { 'type': 'application/pdf' }),
          //     filename
          // );
        }
      })
    },
  }, // end methods
}
